import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-validate-shared-order-page',
  templateUrl: './validate-shared-order-page.component.html',
})
export class ValidateSharedOrderPageComponent {
  @Input() body: any;
}
